module.exports = __webpack_public_path__ + "../resources/img/bg_tit_visual01.a3d7dd2c.jpg";